module.exports = __webpack_public_path__ + "static/media/34.5dd41aca.jpg";